// Escolha do tomador (a filial que recebe a nota) a partir do que o PDF leu.
// Funcao unica para a inclusao manual e para o simulador de regras: as duas
// telas precisam chegar na MESMA filial para o mesmo documento, senao o
// simulador deixa de reproduzir a inclusao.

import { NfseData } from './nfse-parser';

/**
 * CNPJ da filial tomadora, ou '' quando o documento nao permite decidir.
 *
 * 1. O tomador lido pelo rotulo, se for uma das filiais.
 * 2. Senao, o unico CNPJ do documento (fora o emitente) que e filial. O
 *    tomador de uma nota do GNF e sempre filial do grupo, e isso vale para
 *    qualquer layout - inclusive DACTE que imprime rotulos e valores em
 *    blocos separados, onde o rotulo nao aponta o CNPJ certo (750103: CNPJ
 *    sem mascara; Kairos: o regex caia no CNPJ de outra parte).
 * 3. Mais de uma filial no documento (ex.: remetente e tomador do grupo):
 *    devolve '' e a tela pede a escolha. Chutar aqui lanca a nota na filial
 *    errada.
 *
 * @param data          retorno do PdfParserService.parseDanfe
 * @param cnpjsFiliais  CNPJs das filiais, com ou sem mascara
 */
export function tomadorEntreFiliais(data: NfseData, cnpjsFiliais: string[]): string {
  const filiais = new Set(cnpjsFiliais.map(c => (c || '').replace(/\D/g, '')).filter(c => c));
  if (filiais.size === 0) { return ''; }

  const rotulado = (data.cnpjTomador || '').replace(/\D/g, '');
  if (rotulado && filiais.has(rotulado)) { return rotulado; }

  const emitente = (data.cnpjEmissor || '').replace(/\D/g, '');
  const candidatos = (data.cnpjsDocumento ?? []).filter(c => c !== emitente && filiais.has(c));

  return candidatos.length === 1 ? candidatos[0] : '';
}
